import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC006_Request,
  IAPI_FAC006_Response,
  IAPI_FAC010_Request,
  IAPI_FAC010_Response,
} from "../../../type/apiType";

// 職員の異動状況登録表示
const httpAPI_FAC006 = async (
  param: IAPI_FAC006_Request
): Promise<IAPI_FAC006_Response> => {
  let res = await http.post(ApiUrl.API_FAC006, {
    ...param,
  });
  return res.data;
};
// 共済契約対象施設等一部廃止等届職員名簿更新API
const httpAPI_FAC010 = async (
  param: IAPI_FAC010_Request
): Promise<IAPI_FAC010_Response> => {
  let res = await http.post(ApiUrl.API_FAC010, {
    ...param,
  });
  return res.data;
};

export { httpAPI_FAC006, httpAPI_FAC010 };
